import {
  listContexts,
  listFavoriteContexts,
  listUsedContexts,
  listFavoritePrompts,
  listUserPrompts,
  listSharedPrompts,
  listUsedPrompts,
} from '../services/api';

const DEFAULT_LIMIT = 50;

const isActiveCapability = (item) => item?.isDeleted !== true;

function mergeById(lists) {
  const map = new Map();
  lists.flat().forEach((item) => {
    if (item?.id && !map.has(item.id)) {
      map.set(item.id, item);
    }
  });
  return [...map.values()];
}

function sortByName(items, getName = (item) => item?.title || item?.name || '') {
  return [...items].sort((a, b) =>
    String(getName(a)).localeCompare(String(getName(b)), undefined, { sensitivity: 'base' })
  );
}

export async function fetchDefaultAttachPrompts(options) {
  if (options) return listAttachPrompts(options);
  const [createdRes, favoritesRes] = await Promise.all([
    listUserPrompts({ limit: DEFAULT_LIMIT, sortBy: 'recent' }),
    listFavoritePrompts({ limit: DEFAULT_LIMIT }),
  ]);
  const created = createdRes?.prompts || createdRes?.data || [];
  const favorites = favoritesRes?.prompts || favoritesRes?.data || [];
  return sortByName(
    mergeById([created, favorites]).filter(isActiveCapability),
    (p) => p?.title || p?.name
  );
}

export async function searchAttachPrompts(search, options) {
  if (options) return listAttachPrompts({ ...options, search });
  const res = await listUserPrompts({ search: search.trim(), limit: DEFAULT_LIMIT });
  const list = res?.prompts || res?.data || [];
  return sortByName(list.filter(isActiveCapability), (p) => p?.title || p?.name);
}

function getContexts(response) {
  return response?.contexts || response?.data || [];
}

async function listAttachPrompts({ scope = 'user', search = '', category = 'all', sortBy = 'recent', sortDirection = 'desc', limit = DEFAULT_LIMIT } = {}) {
  const filters = { limit, category, sortBy: search.trim() && ['user', 'shared'].includes(scope) ? 'best' : sortBy, sortDirection, ...(search.trim() ? { search: search.trim() } : {}) };
  const fetch = scope === 'favorites' ? listFavoritePrompts : scope === 'recent' ? listUsedPrompts : scope === 'shared' ? listSharedPrompts : listUserPrompts;
  const response = await fetch(filters);
  return (response?.prompts || response?.data || []).filter(isActiveCapability);
}

function contextRequestOptions({ search, category, sortBy, sortDirection, limit } = {}) {
  const hasSearch = Boolean(search?.trim());
  return {
    limit: limit || DEFAULT_LIMIT,
    ...(hasSearch ? { search: search.trim() } : {}),
    ...(category && String(category).toLowerCase() !== 'all' ? { category } : {}),
    ...(sortBy ? { sortBy: hasSearch ? 'best' : sortBy } : {}),
    ...(sortDirection ? { sortDirection: hasSearch ? 'desc' : sortDirection } : {}),
  };
}

async function listAttachContexts({
  scope = 'user',
  search = '',
  category = 'all',
  sortBy = 'recent',
  sortDirection = 'desc',
  limit = DEFAULT_LIMIT,
} = {}) {
  const options = contextRequestOptions({ search, category, sortBy, sortDirection, limit });
  let response;

  if (scope === 'favorites') {
    response = await listFavoriteContexts(options);
  } else if (scope === 'recent') {
    response = await listUsedContexts(options);
  } else {
    response = await listContexts(scope === 'shared' ? 'shared' : 'user', options);
  }

  return getContexts(response);
}

export function fetchDefaultAttachContexts(options = {}) {
  return listAttachContexts(options);
}

export function searchAttachContexts(search, options = {}) {
  return listAttachContexts({ ...options, search });
}
